import React,{useEffect,useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {db} from '../../firebase/firebase.js';
import {doc,getDoc} from 'firebase/firestore';
import '../../styles/BusinessLanding.css';

export default function BusinessLanding(){

  const [params] = useSearchParams();
  const [data,setData] = useState(null);
  const [loading,setLoading] = useState(true);

  useEffect(()=>{
    const bid = params.get('bid');
    if(!bid){
      setLoading(false);
      return;
    }
    loadLanding(bid);
  },[params]);

  const loadLanding = async(bid)=>{
    try{
      const ref = doc(db,'landingPages',bid);
      const snap = await getDoc(ref);

      if(snap.exists()){
        setData(snap.data());
      }else{
        setData(null);
      }

    }catch(err){
      console.error('Landing page load error:',err);
      setData(null);
    }finally{
      setLoading(false);
    }
  };

  if(loading){
    return <div className="lp-container"><h2>Loading...</h2></div>;
  }

  if(!data){
    return <div className="lp-container"><h2>Landing Page Not Found</h2></div>;
  }

  return(
    <div className="lp-container">

      {/* HERO */}
      <div className="lp-hero" style={{background:data.hero.background}}>
        <h1>{data.hero.title}</h1>
        <p>{data.hero.subtitle}</p>
        <a className="lp-cta" href="/quote">{data.hero.cta}</a>
      </div>

      {/* ABOUT */}
      <div className="lp-section">
        <h2>{data.sections.about.title}</h2>
        <p>{data.sections.about.text}</p>
      </div>

      {/* SERVICES */}
      <div className="lp-services">
        {data.sections.services.map((s,i)=>(
          <div key={i} className="lp-service-card">
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </div>
        ))}
      </div>

      {/* CONTACT */}
      <div className="lp-section">
        <h2>{data.sections.contact.title}</h2>
        <a className="lp-cta" href="/quote">{data.sections.contact.cta}</a>
      </div>

    </div>
  );
}
